import MaterialChip from '@mui/material/Chip'
import { useTheme } from '@mui/material/styles'
import { Link } from 'react-router-dom'

const Chip = ({ label, href, color, type = 'track', variant = 'filled' }) => {
  const theme = useTheme()

  return (
    <MaterialChip
      component={href ? Link : 'span'}
      to={href ? href : null}
      label={label}
      variant={variant}
      size="small"
      sx={{
        height: '2rem',
        background:
          type === 'track'
            ? theme.vars.palette.track.solid[color]
            : theme.vars.palette[type][color],
        borderRadius: '0.8rem',
        '& .MuiChip-label': {
          fontWeight: '500',
          fontSize: '1rem',
          lineHeight: '2rem',
        },
      }}
    />
  )
}

export default Chip
